import { useState } from 'react';
import { Button, Modal, Spinner, Form } from 'react-bootstrap';
import { FaPhotoVideo, FaExclamationCircle, FaTrash, FaCheckCircle } from 'react-icons/fa';
import {
  handleDownloadFactura,
  handleDownloadAlbaran,
  handleDownloadSignedAlbaran,
} from '../Global/DownloadUtils';
import { useLocation } from 'react-router-dom';
import { isComercial, isTransportista, isJefeTransportistas, isPropietarioOrAdminOrGestion, isPropietarioOrAdminOrGestionOrEspectador } from '../../services/AuthService';
import { deleteOrder, updateOrder } from '../../api';

const ActionButtons = ({
  order,
  navigate,
  toggleEditRow,
  toggleEditClientRow,
  handlePhotos,
  useTextButtons = false,
  readOnly = false,
  toggleIncidentRow
}) => {
  const isCarrierManager= isJefeTransportistas() && !isComercial() && !isPropietarioOrAdminOrGestionOrEspectador();
  const location = useLocation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeliverModal, setShowDeliverModal] = useState(false);
  const [isMarkingDelivered, setIsMarkingDelivered] = useState(false);

  const openDeleteModal = () => {
    setConfirmationText('');
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    if (!isDeleting) {
      setShowDeleteModal(false);
    }
  };

  const openDeliverModal = () => setShowDeliverModal(true);
  const closeDeliverModal = () => {
    if (!isMarkingDelivered) setShowDeliverModal(false);
  };
  const handleDeliverConfirm = async () => {
    setIsMarkingDelivered(true);
    try {
      const nowUtc = new Date().toISOString();
      await updateOrder(order.id, { id: order.id, deliveredTime: nowUtc });
      setShowDeliverModal(false);
      // refrescar o navegar al detalle
      if (location.pathname.startsWith('/orders/')) {
        navigate('/orders');
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error('Error marcando entregado:', err);
      alert('No se pudo marcar como entregado.');
    } finally {
      setIsMarkingDelivered(false);
    }
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      await deleteOrder(order.id);
      setShowDeleteModal(false);
      // navigate back or reload
      if (location.pathname.startsWith('/orders/')) {
        navigate('/orders');
      } else {
        window.location.reload();
      }
    } catch (err) {
      console.error('Error borrando pedido:', err);
      alert('No se pudo borrar el pedido.');
      setIsDeleting(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center flex-wrap" data-testid={`action-buttons-${order.id}`}>
        {/* Botón o Icono para Detalles del Pedido */}
        {!isCarrierManager && (
          <>
            {location.pathname !== `/orders/${order.id}` && (  // Verificar si no estamos en la página de detalles
              useTextButtons ? (
                <Button
                  style={{
                    backgroundColor: '#007bff', // Color de fondo
                    borderColor: '#007bff',     // Color del borde
                    color: 'white',             // Color del texto
                    fontSize: '0.875rem',       // Tamaño de fuente ajustado
                  }}
                  className="btn mt-3 m-1"
                  onClick={() => navigate(`/orders/${order.id}`)} // Redirigir a la página de detalles del pedido
                  data-testid={`order-details-button-${order.id}`}
                >
                  Detalles del pedido
                </Button>
              ) : (
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => navigate(`/orders/${order.id}`)} // Redirigir a la página de detalles del pedido
                  className="p-0 m-1"
                  style={{ color: '#007bff', fontSize: '1.5rem' }}
                  title="Ver Detalles del Pedido"
                  data-testid={`order-details-icon-${order.id}`}
                >
                  <i className="bi bi-info-circle"></i> {/* Icono de información */}
                </Button>
              )
            )}
          </>
        )}

        {/* Botón o Icono para Pedidos Relacionados */}
        {!isCarrierManager && (
          <>
            {(order.parentId !== null || order.hasIncident) && !location.pathname.includes('related') && (
              useTextButtons ? (
                <Button
                  style={{
                    backgroundColor: '#007bff', // Color de fondo
                    borderColor: '#007bff',     // Color del borde
                    color: 'white',             // Color del texto
                    fontSize: '0.875rem',       // Tamaño de fuente ajustado
                  }}
                  className="btn mt-3 m-1"
                  onClick={() => navigate(`/orders/${order.id}/related`)}
                >
                  Pedidos Relacionados
                </Button>
              ) : (
                <Button
                  variant="link"
                  size="sm"
                  onClick={() => navigate(`/orders/${order.id}/related`)}
                  className="p-0 m-1"
                  style={{ color: '#007bff', fontSize: '1.5rem' }}
                  title="Pedidos relacionados"
                >
                  <i className="bi bi-link-45deg"></i> {/* Icono de enlace */}
                </Button>
              )
            )}
          </>
        )}

        {/* Botón o Icono para Editar */}
        {!order.isFinalStatus && !readOnly && !isCarrierManager && (
          useTextButtons ? (
            <Button
              style={{
                backgroundColor: '#007bff', // Color de fondo
                borderColor: '#007bff',     // Color del borde
                color: 'white',             // Color del texto
                fontSize: '0.875rem',       // Tamaño de fuente ajustado
              }}
              className="btn mt-3 m-1"
              onClick={() => toggleEditRow(order.id)}
              data-testid={`edit-order-button-${order.id}`}
            >
              Editar artículos/señal
            </Button>
          ) : (
            <Button
              variant="link"
              size="sm"
              onClick={() => toggleEditRow(order.id)}
              className="p-0 m-1"
              style={{ color: '#007bff', fontSize: '1.5rem' }}
              title="Editar artículos/señal"
              data-testid={`edit-order-icon-${order.id}`}
            >
              <i className="bi bi-pencil-square"></i>
            </Button>
          )
        )}

        {/* Botón o Icono para Editar Cliente */}
        {!order.isFinalStatus && !readOnly && !isCarrierManager && (
          useTextButtons ? (
            <Button
              style={{
                backgroundColor: '#007bff',
                borderColor: '#007bff',
                color: 'white',
                fontSize: '0.875rem',
              }}
              className="btn mt-3 m-1"
              onClick={() => toggleEditClientRow(order.id)}
              data-testid={`edit-client-button-${order.id}`}
            >
              Editar cliente/dirección
            </Button>
          ) : (
            <Button
              variant="link"
              size="sm"
              onClick={() => toggleEditClientRow(order.id)}
              className="p-0 m-1"
              style={{ color: '#007bff', fontSize: '1.5rem' }}
              title="Editar cliente/dirección"
              data-testid={`edit-client-icon-${order.id}`}
            >
              <i className="bi bi-person-fill-gear"></i>
            </Button>
          )
        )}

        {/* Botón o Icono para Incidencia */}
        {!order.isFinalStatus && !readOnly && !isCarrierManager && (
          useTextButtons ? (
            <Button
              style={{
                backgroundColor: '#007bff', // Color de fondo
                borderColor: '#007bff',     // Color del borde
                color: 'white',             // Color del texto
                fontSize: '0.875rem',       // Tamaño de fuente ajustado
              }}
              className="btn mt-3 m-1"
              onClick={() => toggleIncidentRow(order.id)}
            >
              Marcar como incidencia
            </Button>
          ) : (
            <Button
              variant="link"
              size="sm"
              onClick={() => toggleIncidentRow(order.id)}
              className="p-0 m-1"
              style={{ color: '#007bff', fontSize: '1.5rem' }}
              title="Marcar como incidencia"
            >
              <FaExclamationCircle />
            </Button>
          )
        )}

        {/* Botón o Icono para Descargar Factura */}
        {!isCarrierManager && (
          <>
            {useTextButtons ? (
              <Button
                style={{
                  backgroundColor: '#007bff', // Color de fondo
                  borderColor: '#007bff',     // Color del borde
                  color: 'white',             // Color del texto
                  fontSize: '0.875rem',       // Tamaño de fuente ajustado
                }}
                className="btn mt-3 m-1"
                onClick={() => handleDownloadFactura(order.id)}
              >
                Descargar Detalles de pedido
              </Button>
            ) : (
              <Button
                variant="link"
                size="sm"
                onClick={() => handleDownloadFactura(order.id)}
                className="p-0 m-1"
                style={{ color: '#007bff', fontSize: '1.5rem' }}
                title="Descargar detalles de pedido"
              >
                <i className="bi bi-file-earmark-pdf"></i>
              </Button>
            )}
        </>
        )}

        {/* Botón o Icono para Descargar Albarán */}
        {useTextButtons ? (
          <Button
            style={{
              backgroundColor: '#007bff', // Color de fondo
              borderColor: '#007bff',     // Color del borde
              color: 'white',             // Color del texto
              fontSize: '0.875rem',       // Tamaño de fuente ajustado
            }}
            className="btn mt-3 m-1"
            onClick={() => handleDownloadAlbaran(order.id)}
          >
            Descargar Albarán
          </Button>
        ) : (
          <Button
            variant="link"
            size="sm"
            onClick={() => handleDownloadAlbaran(order.id)}
            className="p-0 m-1"
            style={{ color: '#007bff', fontSize: '1.5rem' }}
            title="Descargar Albarán"
          >
            <i className="bi bi-file-earmark-pdf"></i>
          </Button>
        )}

        {/* Botón o Icono para Descargar Albarán Firmado */}
        {order.hasSignedAlbaran && (isPropietarioOrAdminOrGestion() || isTransportista() || isJefeTransportistas()) &&
          (useTextButtons ? (
            <Button
              style={{
                backgroundColor: '#007bff', // Color de fondo
                borderColor: '#007bff',     // Color del borde
                color: 'white',             // Color del texto
                fontSize: '0.875rem',       // Tamaño de fuente ajustado
              }}
              className="btn mt-3 m-1"
              onClick={() => handleDownloadSignedAlbaran(order.id)}
            >
              Descargar Albarán Firmado
            </Button>
          ) : (
            <Button
              variant="link"
              size="sm"
              onClick={() => handleDownloadSignedAlbaran(order.id)}
              className="p-0 m-1"
              style={{ color: '#007bff', fontSize: '1.5rem' }}
              title="Descargar Albarán Firmado"
            >
              <i className="bi bi-file-earmark-pdf"></i>
            </Button>
          ))}

        {/* Botón o Icono para Ver Fotos */}
        {order.hasImage &&
          (useTextButtons ? (
            <Button
              style={{
                backgroundColor: '#007bff', // Color de fondo
                borderColor: '#007bff',     // Color del borde
                color: 'white',             // Color del texto
                fontSize: '0.875rem',       // Tamaño de fuente ajustado
              }}
              className="btn mt-3 m-1"
              onClick={() => handlePhotos(order.id)}
            >
              Ver Fotos
            </Button>
          ) : (
            <Button
              variant="link"
              size="sm"
              onClick={() => handlePhotos(order.id)}
              className="p-0 m-1"
              style={{ color: '#007bff', fontSize: '1.5rem' }}
              title="Ver Fotos"
            >
              <FaPhotoVideo />
            </Button>
          ))}

          {isPropietarioOrAdminOrGestion() && !order.deliveredTime && !order.hasIncident && (
            useTextButtons ? (
              <Button
                variant="success"
                className="btn mt-3 m-1"
                onClick={openDeliverModal}
              >
                Marcar entregado
              </Button>
            ) : (
              <Button
                variant="link"
                size="sm"
                onClick={openDeliverModal}
                className="p-0 m-1"
                style={{ color: 'green', fontSize: '1.5rem' }}
                title="Marcar entregado"
              >
                <FaCheckCircle />
              </Button>
            )
          )}

          {isPropietarioOrAdminOrGestion() && (
            useTextButtons ? (
              <Button
                variant="danger"
                className="btn mt-3 m-1"
                onClick={openDeleteModal}
              >
                Borrar pedido
              </Button>
            ) : (
              <Button
                variant="link"
                size="sm"
                onClick={openDeleteModal}
                className="p-0 m-1"
                style={{ color: 'red', fontSize: '1.5rem' }}
                title="Borrar pedido"
              >
                <FaTrash />
              </Button>
            )
          )}
      
      </div>
      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
          <Modal.Header closeButton={!isDeleting}>
            <Modal.Title>Confirmar borrado</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div 
              style={{ 
                userSelect: 'none', 
                WebkitUserSelect: 'none', 
                MozUserSelect: 'none' 
              }}
            >
              <p>¡Cuidado! Esta acción eliminará <strong>permanentemente</strong> el pedido <em>{order.externalId || order.id}</em>.</p>
              <p>Para confirmar, escribe <strong>ENTENDIDO</strong> en el campo de abajo.</p>
            </div>
            <Form.Group className="mt-3">
              <Form.Control
                type="text"
                placeholder="Escribe ENTENDIDO"
                value={confirmationText}
                onChange={e => setConfirmationText(e.target.value)}
                disabled={isDeleting}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeDeleteModal} disabled={isDeleting}>
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteConfirm}
              disabled={confirmationText.trim().toLowerCase() !== 'entendido' || isDeleting}
            >
              {isDeleting ? <Spinner animation="border" size="sm" /> : 'Borrar definitivamente'}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showDeliverModal} onHide={closeDeliverModal} centered>
          <Modal.Header closeButton={!isMarkingDelivered}>
            <Modal.Title>Confirmar entrega</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            ¿Deseas marcar el pedido <strong>{order.externalId || order.id}</strong> como entregado?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={closeDeliverModal}
              disabled={isMarkingDelivered}
            >
              Cancelar
            </Button>
            <Button
              variant="success"
              onClick={handleDeliverConfirm}
              disabled={isMarkingDelivered}
            >
              {isMarkingDelivered
                ? <Spinner animation="border" size="sm" />
                : 'Confirmar entrega'}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
  );
};

export default ActionButtons;
